export default __webpack_public_path__ + "static/media/orange_paper_rip.7dbc6f35.png";